export const PRODUCTS_LANG = {}
